import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import { labels } from "../../../localization/labels";
import { onlyUnique } from "../../../utils/CommonUtil";
import Tag from "../Tag/Tag";

class TagContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      tags: [],
      inputVisible: false,
      inputValue: ""
    };

    this.controlId = this.props.controlId || "tags";
    this.maxTagLength = 200;
  }

  handleClose = removedTag => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    this.setState({ tags });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: ""
    });
  };

  saveInputRef = input => (this.input = input);

  handleTagsChange = data => {
    const tags = this.state.tags;
    const updatedTags = data
      .map(element => element.name || element)
      .map(tagString => tagString.toUpperCase())
      .filter(onlyUnique)
      .map(tagString => {
        const tag = tags.find(item => item.name.toUpperCase() === tagString);
        if (tagString.length <= this.maxTagLength) {
          return tag ? tag : { name: tagString };
        } else {
          return tag
            ? tag
            : { name: tagString.substr(0, this.maxTagLength - 1) };
        }
      });
    this.props.onChange({
      target: { id: this.controlId, value: updatedTags }
    });
    this.setState({ tags: updatedTags });
  };

  componentDidUpdate() {
    let { isLoading } = this.state;
    if (this.props.reload) {
      isLoading = true;
      this.props.reloaded();
    }
    if (isLoading || this.props.changed) {
      if (this.props.tags && this.props.tags !== this.state.tags) {
        this.setState({ tags: [...this.props.tags], isLoading: false });
        this.props.disableChanged && this.props.disableChanged();
      }
    }
  }

  renderTag = props => {
    let {
      tag,
      key,
      disabled,
      onRemove,
      classNameRemove,
      getTagDisplayValue,
      ...other
    } = props;
    return (
      <span key={key} {...other}>
        {getTagDisplayValue(tag.name)}
        {!disabled && !this.props.onAddClick && (
          <CloseOutlined
            title={labels.removeFromTags}
            className={`${classNameRemove} tag-icons`}
            onClick={e => {
              this.props.onRemoveClick && this.props.onRemoveClick(tag.name);
              onRemove(key);
            }}
          />
        )}
        {!disabled && this.props.onAddClick && !tag.hideAdd && (
          <PlusOutlined
            className={`${classNameRemove} tag-icons`}
            onClick={e => this.props.onAddClick(tag.name)}
            title={labels.addToTag}
          />
        )}
      </span>
    );
  };

  renderLayout = (tagComponents, inputComponent) => {
    return (
      <span>
        {tagComponents}
        {!this.props.disableInput && inputComponent}
      </span>
    );
  };

  render() {
    return (
      <Tag
        tags={this.state.tags}
        handleTagsChange={this.handleTagsChange}
        disabled={this.props.disabled}
        renderTag={this.renderTag}
        renderLayout={this.renderLayout}
      />
    );
  }
}
export default TagContainer;
